import { useState } from 'react';

import {
  isNotificationPermissionPending,
  requestNotificationPermission,
} from '@web/common/utils/browserAPI/notification';
import {
  getClientSettings,
  updateClientSetings,
} from '@web/settings/components/notifications/helpers/handleClientSettings';

function shouldDisplayBanner() {
  // if there's no localStorage user settings
  const settings = getClientSettings();
  if (!settings) return true;

  const { didPresentNotificationQuestion, notifications } = settings;
  const isNotificationSettingDefined = notifications !== null && notifications !== undefined;

  if (!didPresentNotificationQuestion || !isNotificationSettingDefined) return true;

  // browser permission has not been granted or denied yet
  // this will handle a scenario where user reset browser permissions,
  // while global settings are already set
  if (didPresentNotificationQuestion && notifications && isNotificationPermissionPending()) {
    return true;
  }

  return false;
}

export const useRequestMessageNotification = () => {
  const [isDecisionPending, setIsDecisionPending] = useState(shouldDisplayBanner);

  const readUsersDecision = async (answer: boolean) => {
    let accepted = answer;

    if (answer) {
      const permission = await requestNotificationPermission();
      // if a user clicked on `yes` but then selected `block` (denied) on the
      // browser's permission prompt, then he actually decided to disable whole feature
      accepted = permission === 'granted' ? true : false;
    }

    updateClientSetings({
      didPresentNotificationQuestion: true,
      notifications: accepted,
    });

    setIsDecisionPending(false);
  };

  return {
    readUsersDecision,
    isDecisionPending,
  };
};
